const host = "https://www.manage.sesimplify.com";
// const host = "https://4f9b-122-161-48-191.in.ngrok.io";

const global_url = `${host}/api`

export {host, global_url};